import script from "./base-certificate-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-certificate-modal.vue?vue&type=script&setup=true&lang=ts"

import "./base-certificate-modal.vue?vue&type=style&index=0&id=631d6c1e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631d6c1e"]])

export default __exports__